import BackendError from './backendError';

export enum WebActions {
    SIGNING_STATUS_UPDATE_PAYMENT = 'SIGNING_STATUS_UPDATE_PAYMENT',
    SIGNING_CANCEL = 'SIGNING_CANCEL',
    SIGNING_ERROR = 'SIGNING_ERROR',
    PAYMENT_CANCEL = 'PAYMENT_CANCEL',
    BACK_TO_WEB = 'BACK_TO_WEB',
    BROWSER_CALLBACK_RESULT = 'BROWSER_CALLBACK_RESULT',
    REACT_NATIVE_PROPS_UPDATED = 'REACT_NATIVE_PROPS_UPDATED',
    DEEPLINK_RESULT = 'DEEPLINK_RESULT',
    STEP_UP_AUTH_RESULT = 'STEP_UP_AUTH_RESULT',
    STEP_UP_AUTH_ERROR = 'STEP_UP_AUTH_ERROR',
    STEP_UP_AUTH_CAPTURE_FINISH = 'STEP_UP_AUTH_CAPTURE_FINISH',
    GTP_TOKENIZATION_RESULT = 'GTP_TOKENIZATION_RESULT',
    GTP_TOKENIZATION_ERROR = 'GTP_TOKENIZATION_ERROR',
    GTP_WALLET_INFO_RESULT = 'GTP_WALLET_INFO_RESULT',
    GTP_WALLET_INFO_ERROR = 'GTP_WALLET_INFO_ERROR',
    GTP_PUSH_PROVISION_RESULT = 'GTP_PUSH_PROVISION_RESULT',
    GTP_PUSH_PROVISION_ERROR = 'GTP_PUSH_PROVISION_ERROR',
}

type PaymentStatus = 'CREATED' | 'CANCELLED' | 'REJECTED' | 'PROCESSING' | 'COMPLETED' | 'UNKNOWN' | 'EXPIRED';

export interface StepUpAuthResult {
    passed: boolean;
    padPassed: boolean;
    faceMatchPassed: boolean;
}

export type StepUpAuthError = string | BackendError;

export interface GtpTokenizationResult {
    cardLast4Digits: string;
    isTokenized: boolean;
}

export interface GtpWalletInfoResult {
    activeWalletId: string;
    deviceStableHardwareId: string;
    isDefaultWallet: boolean;
    bundleId: string;
}

export interface GtpPushProvisionResult {
    success: boolean;
    tokenReferenceId?: string;
}

export type RNToWebPayloadList = {
    [WebActions.SIGNING_STATUS_UPDATE_PAYMENT]: PaymentStatus;
    [WebActions.SIGNING_CANCEL]: undefined;
    [WebActions.SIGNING_ERROR]: SigningError;
    [WebActions.PAYMENT_CANCEL]: undefined;
    [WebActions.BACK_TO_WEB]: undefined;
    [WebActions.BROWSER_CALLBACK_RESULT]: string;
    [WebActions.REACT_NATIVE_PROPS_UPDATED]: undefined;
    [WebActions.DEEPLINK_RESULT]: string;
    [WebActions.STEP_UP_AUTH_RESULT]: StepUpAuthResult;
    [WebActions.STEP_UP_AUTH_ERROR]: StepUpAuthError;
    [WebActions.STEP_UP_AUTH_CAPTURE_FINISH]: undefined;
    [WebActions.GTP_PUSH_PROVISION_RESULT]: GtpPushProvisionResult;
    [WebActions.GTP_PUSH_PROVISION_ERROR]: string;
    [WebActions.GTP_TOKENIZATION_RESULT]: GtpTokenizationResult;
    [WebActions.GTP_TOKENIZATION_ERROR]: string;
    [WebActions.GTP_WALLET_INFO_RESULT]: GtpWalletInfoResult;
    [WebActions.GTP_WALLET_INFO_ERROR]: string;
};

export interface RNToWebMessage<Action extends keyof RNToWebPayloadList> {
    action: Action;
    payload: RNToWebPayloadList[Action];
}

export enum SigningError {
    DYNAMIC_LINK_EXPIRED = 'DYNAMIC_LINK_EXPIRED',
}
